import { render, staticRenderFns } from "./DetalheMelhoresEntregasLeiteProdutores.vue?vue&type=template&id=2cc1c256&"
import script from "./DetalheMelhoresEntregasLeiteProdutores.vue?vue&type=script&lang=js&"
export * from "./DetalheMelhoresEntregasLeiteProdutores.vue?vue&type=script&lang=js&"
import style0 from "./DetalheMelhoresEntregasLeiteProdutores.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
